/**
 * Determines if the supplied URL is an image
 **/
const isImage = url => /\.(jpe?g|gif|png|avif|svg)$/i.test(url);

export const isJpgOrPng = url => /\.(jpe?g|png)$/i.test(url);

export default isImage;
